module.exports = __webpack_public_path__ + "./images/a95ebe20a429c99d8035b111925e8f01.webp";